import { z } from 'zod';

import { PayoffId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GeneratePaidInFullStatementSideEffectContext = BaseLoanIdSideEffect.extend({
  payoffId: PayoffId,
});
export const GeneratePaidInFullStatementSideEffect = GeneratePaidInFullStatementSideEffectContext.extend({
  type: z.literal('generatePaidInFullStatement'),
});
export type GeneratePaidInFullStatementSideEffect = z.infer<typeof GeneratePaidInFullStatementSideEffect>;
